import Vue from 'vue';

import './plugins/vue-cookies';
import './plugins/vuetify';

import '@/assets/sass/global.scss';

import moment from 'moment';
import Big from 'big.js/big.mjs';

import router from './router';
import store from './store';

import helpers from './helpers';
import axios from './axios';
import api from './api';
import language from './language';

import App from './App.vue';

Vue.prototype.$helpers = helpers;
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$language = language;
Vue.prototype.$Big = Big;

Vue.prototype.$getMonths = () => {
  const months = [];
  const instance = moment(new Date());
  for (let i = 1; i <= 12; i += 1) {
    const format = instance.format('YYYY-MM');
    const [year, month] = format.split('-');
    months.push({ format, Year: parseInt(year, 10), Month: parseInt(month, 10) });
    instance.add(1, 'month');
  }
  return months;
};
Vue.prototype.$getFormat = (Year, Month) => `${Year}-${Month < 10 ? `0${Month}` : Month}`;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
